import type { DocEntityBase } from "building-types/entities/docEntityBase";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";

export type SystemEntityEligibleEntityHandle = Extract<
  DocEntityHandle,
  {
    type:
      | "GROUP"
      | "OPTION_SET"
      | "LABEL"
      | "PRESET"
      | "SYSTEM_PARAMETER"
      | "DATUM"
      | "FRAMING_COMPONENT"
      | "CIP_COMPONENT"
      | "MASONRY_COMPONENT"
      | "SHEATHING_COMPONENT"
      | "FOUNDATION_ASSEMBLY"
      | "FOUNDATION_COMPONENT"
      | "HEADER_ASSEMBLY"
      | "DATA_SEQUENCE"
      | "FRAME_FLOOR_ASSEMBLY"
      | "SLAB_FLOOR_ASSEMBLY"
      | "SLAB_COMPONENT"
      | "WALL_PLANE_ASSEMBLY"
      | "CONTENT_TEMPLATE"
      | "PROFILE";
  }
>;

export type SystemEntityEligibleEntityType = SystemEntityEligibleEntityHandle["type"];

export const systemEntityEligibleEntities: { [key in SystemEntityEligibleEntityType]: true } = {
  GROUP: true,
  OPTION_SET: true,
  LABEL: true,
  PRESET: true,
  SYSTEM_PARAMETER: true,
  DATUM: true,
  FRAMING_COMPONENT: true,
  CIP_COMPONENT: true,
  MASONRY_COMPONENT: true,
  SHEATHING_COMPONENT: true,
  FOUNDATION_ASSEMBLY: true,
  FOUNDATION_COMPONENT: true,
  HEADER_ASSEMBLY: true,
  DATA_SEQUENCE: true,
  FRAME_FLOOR_ASSEMBLY: true,
  SLAB_FLOOR_ASSEMBLY: true,
  SLAB_COMPONENT: true,
  WALL_PLANE_ASSEMBLY: true,
  CONTENT_TEMPLATE: true,
  PROFILE: true,
} as const;

export const systemEntityEligibleEntityTypes = Object.keys(
  systemEntityEligibleEntities,
) as SystemEntityEligibleEntityType[];

export type SystemEntityEligibleEntity<T extends SystemEntityEligibleEntityType = SystemEntityEligibleEntityType> =
  DocEntityBase<T>;
